


























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as $ from 'jquery';

import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { UserModule } from '@/store/modules/user';

import ListSaveWidget from '@/components/ListSaveWidget.vue';

@Component({ components: { ListSaveWidget } })
export default class ListCard extends Vue {
  @Prop(ListModel) public list!: ListModel;
  listToDelete: ListModel = null;

  fixUrl(imgUrl: string) {
    return imgUrl.split('?')[0];
  }

  get canEditList() {
    return ListModelUtil.canEditList(this.list, UserModule.currentUserId);
  }

  // TODO: share all this with ListOwnerView
  overflowOpenId: string = null;
  swipeOpenItemIds: string[] = [];

  closeAllOverflows() {
    this.overflowOpenId = null;
    // @ts-ignore
    $('.menuOpen')
      .removeClass('menuOpen')
      .attr(
        'style',
        'display: none; opacity: 0; transform: translate3d(0px, 100%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;'
      );
  }

  showOverflowMenu(list: ListModel) {
    if (this.overflowOpenId == list.id) {
      this.closeAllOverflows();
      return;
    }

    this.closeAllOverflows();
    this.overflowOpenId = list.id;
    // @ts-ignore
    $(`.container__overflow-menu[data-list-id='${list.id}']`)
      .addClass('menuOpen')
      .attr(
        'style',
        'display: block; opacity: 1; transform: translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;'
      );
  }

  swipeOpened(list: ListModel, dir: string) {
    if (dir == 'left') {
      this.swipeOpenItemIds.push(list.id);
    } else {
      this.swipeOpenItemIds = this.swipeOpenItemIds.filter(i => i !== list.id);
    }
  }

  isRevealed(list: ListModel): boolean {
    return this.swipeOpenItemIds.indexOf(list.id) > -1;
  }

  showDeleteConfirmModal(list: ListModel) {
    // @ts-ignore
    $(`.modal__confirmation[data-list-id='${list.id}']`).show();
  }

  closeDeleteConfirmModal() {
    // @ts-ignore
    $(`.modal__confirmation`).hide();
  }

  deleteList() {
    ListModelUtil.deleteList(this.list);
    this.closeDeleteConfirmModal();
    this.closeAllOverflows();
  }

  get images() {
    if (!this.list.images) {
      return [];
    }
    if (this.list.images.length == 3) {
      return this.list.images.slice(0, 2);
    }
    return this.list.images.slice(0, 4);
  }

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }

  get srcSetOptions() {
    return [
      {
        options: {
          fit: 'crop',
          crop: 'entropy',
          auto: 'format',
          w: 213,
          h: 103
        },
        width: '213w'
      },
      {
        options: { w: 100 },
        width: '100w'
      }
    ];
  }
}
